<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="row bg-white bottom-page-shadow rounded-bottom-extra mx-1">
    <div class="col pt-3 ">
      <p> <span class="fw-bold">Penyenggaraan</span> - Agihan </p>
      <ul class="nav nav-pills nav-justified mb-3 tabs-bg shadow rounded py-2 ps-10 pe-10 mx-4" id="pills-tab"
          role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="pills-ejen-cukai-tab" data-bs-toggle="pill"
                  data-bs-target="#pills-ejen-cukai" type="button" role="tab" aria-controls="pills-ejen-cukai"
                  aria-selected="true" (click)="ResetValue()">
            Ejen Cukai
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-selain-ejen-cukai-tab" data-bs-toggle="pill"
                  data-bs-target="#pills-selain-ejen-cukai" type="button" role="tab"
                  aria-controls="pills-selain-ejen-cukai" aria-selected="false" (click)="ResetValue()">
            Selain Ejen Cukai
          </button>
        </li>
      </ul>
      <div class="tab-content pb-5 mx-4" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-ejen-cukai" role="tabpanel" aria-labelledby="pills-ejen-cukai-tab" tabindex="0">
          <div class="row pt-3">
            <div class="col-4">
              <select class="form-select border-0 shadow" [(ngModel)]="AgentInput" [ngModelOptions]="{standalone: true}">
                <option value="">Ejen Cukai</option>
                <option *ngFor="let res of AgentListView" [value]="res.taxAgentID">{{res.taxAgentName}}</option>
              </select>
            </div>
            <div class="col-4" [ngClass]="AgentInput === '' ? 'd-none' : ''">
              <select class="form-select border-0 shadow" [(ngModel)]="RoleInput" [ngModelOptions]="{standalone: true}">
                <option value="">Kumpulan Pengguna</option>
                <!--<option value="0201">Pentadbir</option>-->
                <option value="0202">Penyelia</option>
                <option value="0203">Staf</option>
              </select>
            </div>
            <div class="col-3">
              <div class="btn-toolbar d-flex justify-content-center">
                <div class="me-2">
                  <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="HantarAgent(AgentInput,RoleInput)">Hantar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-4" *ngIf="AgentStatus">
            <div class="col ">
              <!-- new acordion -->
              <div class="accordion">
                <div class="accordion-item border-0 ">
                  <h2 class="accordion-header shadow m-0 " id="panel-header">
                    <button class="accordion-button primary-colour text-black rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#panel-body" aria-expanded="true" aria-controls="panel-body">
                      Agihan
                    </button>
                  </h2>
                  <div id="panel-body" class="accordion-collapse collapse show shadow" style="background-color: #F5F5F5;" aria-labelledby="panel-header">
                    <div class="accordion-body">
                      <div cdkDropListGroup class="d-flex justify-content-center align-items-center">
                        <div class="drag-container">
                          <h4>Belum Diagih</h4>
                          <div [ngClass]="StaffWithoutRelationshipWithAgentListView.length === 0 ? 'height-empty' : ''" cdkDropList [cdkDropListData]="StaffWithoutRelationshipWithAgentListView" class="shadow" (cdkDropListDropped)="dropWithout($event)">
                            <div class="example-box" *ngFor="let item of StaffWithoutRelationshipWithAgentListView" cdkDrag [cdkDragDisabled]="item.disabled">{{item.staffName}}</div>
                          </div>
                        </div>

                        <div class="drag-container">
                          <h4>Telah Diagih</h4>
                          <div [ngClass]="StaffWithRelationshipWithAgentListView.length === 0 ? 'height-empty' : ''" cdkDropList [cdkDropListData]="StaffWithRelationshipWithAgentListView" class="shadow" (cdkDropListDropped)="dropWith($event)">
                            <div class="single-box" *ngFor="let item of StaffWithRelationshipWithAgentListView" cdkDrag>{{item.staffName}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4 d-flex justify-content-center align-items-center">
                        <img src="./assets/icons/hand-to-left.svg" width="21" height="30" class="card-img-top card-image1" alt="..." />
                      </div>
                      <div class="col-4">
                        <div class="btn-toolbar d-flex justify-content-center pb-3">
                          <div class="me-2">
                            <button type="button" class="btn button-white-sm border-0 shadow rounded-2" role="button" (click)="SubmitAgentAdd(AgentIDConst,StaffWithRelationshipWithAgentListInput,StaffWithoutRelationshipWithAgentListInput)">Simpan</button>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 d-flex justify-content-center align-items-center">
                        <img src="./assets/icons/hand-to-right.svg" width="21" height="30" class="card-img-top card-image1" alt="..." />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="pills-selain-ejen-cukai" role="tabpanel" aria-labelledby="pills-selain-ejen-cukai-tab" tabindex="0">
          <div class="row pt-3">
            <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="SupervisorInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Penyelia</option>
                  <option *ngFor="let res of SupervisorListView" [value]="res.staffID">{{res.staffName}}</option>
                </select>
            </div>
            <div class="col-3">
              <div class="btn-toolbar d-flex justify-content-center">
                <div class="me-2">
                  <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="HantarSupervisor(SupervisorInput)">Hantar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-4" *ngIf="StaffStatus">
            <div class="col ">
              <!-- new acordion -->
              <div class="accordion">
                <div class="accordion-item border-0 ">
                  <h2 class="accordion-header shadow m-0 " id="panel-header">
                    <button class="accordion-button primary-colour text-black rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#panel-body" aria-expanded="true" aria-controls="panel-body">
                      Agihan
                    </button>
                  </h2>
                  <div id="panel-body" class="accordion-collapse collapse show shadow" style="background-color: #F5F5F5;" aria-labelledby="panel-header">
                    <div class="accordion-body">
                      <div cdkDropListGroup class="d-flex justify-content-center align-items-center">
                        <div class="drag-container">
                          <h4>Belum Diagih</h4>
                          <div [ngClass]="StaffWithoutRelationshipWithSupervisorListView.length === 0 ? 'height-empty' : ''" cdkDropList [cdkDropListData]="StaffWithoutRelationshipWithSupervisorListView" class="shadow " (cdkDropListDropped)="dropSupervisorWithout($event)">
                            <div class="single-box" *ngFor="let item of StaffWithoutRelationshipWithSupervisorListView" cdkDrag>{{item.staffName}}</div>
                          </div>
                        </div>

                        <div class="drag-container">
                          <h4>Telah Diagih</h4>
                          <div [ngClass]="StaffWithRelationshipWithSupervisorListView.length === 0 ? 'height-empty' : ''" cdkDropList [cdkDropListData]="StaffWithRelationshipWithSupervisorListView" class="shadow" (cdkDropListDropped)="dropSupervisorWith($event)">
                            <div class="single-box" *ngFor="let item of StaffWithRelationshipWithSupervisorListView" cdkDrag>{{item.staffName}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4 d-flex justify-content-center align-items-center">
                        <img src="./assets/icons/hand-to-left.svg" width="21" height="30" class="card-img-top card-image1" alt="..." />
                      </div>
                      <div class="col-4">
                        <div class="btn-toolbar d-flex justify-content-center pb-3">
                          <div class="me-2">
                            <button type="button" class="btn button-white-sm border-0 shadow rounded-2" role="button" (click)="SubmitSupervisorAdd(SupervisorConst,StaffWithRelationshipWithSupervisorListInput,StaffWithoutRelationshipWithSupervisorListInput)">Simpan</button>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 d-flex justify-content-center align-items-center">
                        <img src="./assets/icons/hand-to-right.svg" width="21" height="30" class="card-img-top card-image1" alt="..." />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
